function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { makeAutoObservable } from 'mobx';
import { User, UserRole } from '../models/User';
import { msalInstance } from '../authConfig';
import userApi from '../api/userApi';
import { TokenUtils } from '../utils/TokenUtils';
export var AuthStore = /*#__PURE__*/ function() {
    "use strict";
    function AuthStore() {
        var _this = this;
        _class_call_check(this, AuthStore);
        _define_property(this, "isLoggedIn", false);
        _define_property(this, "loggedInUser", null);
        _define_property(this, "isLoading", false);
        _define_property(this, "logout", function() {
            TokenUtils.removeJwtToken();
            _this.isLoggedIn = false;
            _this.loggedInUser = null;
            msalInstance.logoutRedirect();
        });
        makeAutoObservable(this);
    }
    _create_class(AuthStore, [
        {
            key: "getUserData",
            value: function getUserData(account) {
                return _async_to_generator(function() {
                    var principal, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.setIsLoading(true);
                                if (!((account === null || account === void 0 ? void 0 : account.name) && !this.isLoggedIn)) return [
                                    3,
                                    6
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    userApi.internalPrincipal.getCurrent()
                                ];
                            case 2:
                                principal = _state.sent().data;
                                this.createUserFromAccount(account, principal);
                                this.setIsLoggedIn(true);
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                error = _state.sent();
                                console.error(error);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                this.setIsLoading(false);
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                this.setIsLoading(false);
                                _state.label = 7;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createUserFromAccount",
            value: function createUserFromAccount(accountInfo, principal) {
                if (principal != null && this.isValidRoles(principal.role)) {
                    this.loggedInUser = new User();
                    this.loggedInUser.id = principal.userId;
                    this.loggedInUser.username = accountInfo.name || principal.username;
                    this.loggedInUser.role = principal.role;
                } else {
                    this.isLoggedIn = false;
                    this.loggedInUser = null;
                    msalInstance.logoutRedirect();
                }
            }
        },
        {
            key: "isValidRoles",
            value: function isValidRoles(role) {
                return role === UserRole.ADMIN;
            }
        },
        {
            key: "setIsLoading",
            value: function setIsLoading(value) {
                this.isLoading = value;
            }
        },
        {
            key: "setIsLoggedIn",
            value: function setIsLoggedIn(value) {
                this.isLoggedIn = value;
            }
        }
    ]);
    return AuthStore;
}();
